import create from 'zustand/vanilla';
import createHook from 'zustand';

export const sessionStore = create((set) => ({
  sessionDrawerUID: null,
  bookLMPSessionData: {},
  setSessionDrawerUID: (uid) =>
    set((state) => ({
      ...state,
      sessionDrawerUID: uid
    })),
  setBookLMPSessionData: (data, isReset) =>
    set((state) => ({
      ...state,
      bookLMPSessionData: isReset
        ? {}
        : {
            ...state.bookLMPSessionData,
            ...data
          }
    }))
}));

const useSessionStore = createHook(sessionStore);

export default useSessionStore;
